import React, { useEffect, useState } from "react";
import ApexCharts from "react-apexcharts";
import Content from "../../../components/Contents/Content";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { House, Tally1, Lock, Rocket } from "lucide-react";
import { Bar } from "react-chartjs-2";
import Chart from "react-apexcharts";

import { CircleUserRound, ShoppingCart, History, Shield, CreditCard, Puzzle } from 'lucide-react'
import { getpastperformaceCashdata, getpastperformaceFuturedata, getpastperformaceOptiondata, GetUserData, getdocumentfile } from "../../../Services/UserService/User";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { clientKycAndAgreement } from "../../../Services/UserService/User"
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import Loader from "../../../../Utils/Loader";
import ReusableModal from '../../../components/Models/ReusableModal';
import {
  getbannerlist,
} from "../../../Services/Admin/Admin";

import { GetBlogData, getbannerUserlist } from "../../../Services/UserService/User";
import { GetNewsData } from "../../../Services/UserService/User";
import { image_baseurl } from "../../../../Utils/config";
import { Getdashboardata } from "../../../Services/UserService/User";
import Kyc from "../Profile/Kyc";



const Dashboard = () => {



  const [cashpastdata, setCashPastdata] = useState([]);
  const [futurepastdata, setFuturePastdata] = useState([]);
  const [optionpastdata, setOptionPastdata] = useState([]);
  const [cashAvgProfit, setCashAvgProfit] = useState(0);
  const [futureAvgProfit, setFutureAvgProfit] = useState(0);
  const [optionAvgProfit, setOptionAvgProfit] = useState(0);
  const [months, setMonths] = useState([]);
  const [bannerimg, setBannerimg] = useState([]);
  const [blogslist, setBlogslist] = useState([]);
  const [newslist, setNewslist] = useState([]);
  const [model, setModel] = useState(false);
  const [viewmodel2, setViewModel2] = useState(false);
  const [cashChartData, setCashChartData] = useState(null);
  const [futureChartData, setFutureChartData] = useState(null);
  const [optionChartData, setOptionChartData] = useState(null);

  const [image, setImage] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTox5GjcAiQFx_AhZfdb1Y4Y5TViXM613ATDg&s"
  );



  const location = useLocation();
  const [userDetail, setUserDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");
  const [dashboard, setDashboard] = useState({});
  const [userdata, setUserdata] = useState([]);
  const [activeplan, setActiveplan] = useState([]);

  const navigate = useNavigate()


  useEffect(() => {

    getCashpastdata();
    getFuturepastdata();
    getOptionpastdata();
    getBannerList();
    getNewslist();
    getBloglist();
    getuserdetail();
    getdashboardata();
    fetchUserData();


  }, []);



  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    aadhar: "",
    panno: "PAN",
  });




  const [touched, setTouched] = useState({
    fullName: false,
    email: false,
    phone: false,
    aadhar: false,
    panno: false,
  });

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    aadhar: "",
    panno: "",
  });





  const fetchUserData = async () => {
    try {
      const userData = await GetUserData(userid, token);
      if (userData && userData.data) {
        setUserdata(userData.data)
      }
    } catch (error) {
      showCustomAlert("error", "Failed to load user data. Please refresh and try again.");
    }
  };



  const getBannerList = async () => {
    try {
      const response = await getbannerUserlist(token);
      setBannerimg(response.data);
    } catch (error) {
      console.error("Error fetching banner list:", error);
    }
  };



  const getNewslist = async () => {
    try {
      const response = await GetNewsData(token);
      setNewslist(response.data);
    }
    catch (error) {
      console.error("Error fetching blog list:", error);
    }

  };


  const getBloglist = async () => {
    try {
      const response = await GetBlogData(token);
      setBlogslist(response.data);
    }
    catch (error) {
      console.error("Error fetching blog list:", error);
    }
  };




  const getdashboardata = async () => {
    try {
      const data = { client_id: userid }
      const response = await Getdashboardata(data, token);

      if (response) {
        setDashboard(response);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };



  const formatMonth = (key) => {
    const [year, month] = key.split("-");
    return new Date(year, month - 1).toLocaleString("en-US", { month: "long" });
  };



  const getuserdetail = async () => {
    try {
      const response = await GetUserData(userid, token);

      if (response.status) {
        setUserDetail(response.data);
        setImage(response?.data?.image)
      }
    } catch (error) {
      console.log("error", error);
    }
  };



  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66d2c3bebf7e6dc53ed07626" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];

  //       const months = lastDuration?.months || {};

  //       // 🔹 Dynamic total investment = sum of totalProfit + totalLoss of all months
  //       let totalProfitSum = 0;
  //       let totalLossSum = 0;
  //       Object.values(months).forEach((m) => {
  //         totalProfitSum += m?.totalProfit ?? 0;
  //         totalLossSum += m?.totalLoss ?? 0;
  //       });
  //       const totalInvestment = totalProfitSum + totalLossSum || 1; // avoid divide by zero

  //       // 🔹 Dynamic future profit percentage
  //       const lastNetProfit = lastDuration?.totalNetProfit ?? 0;
  //       const futureProfitPercentage = ((lastNetProfit / totalInvestment) * 100).toFixed(2);

  //       setCashAvgProfit(Number(futureProfitPercentage)); // 🔹 now in percent

  //       // 🔹 Month-wise chart data
  //       const monthWiseData = {};
  //       const monthWiseProfitLoss = {};

  //       Object.keys(months).forEach((month) => {
  //         const [year, m] = month.split("-");
  //         const monthKey = `${year}-${m.padStart(2, "0")}`;
  //         const { netProfit, totalProfit, totalLoss } = months[month];

  //         // 🔹 Dynamic per-month percentage
  //         const monthInvestment = totalProfit + totalLoss || 1;
  //         const monthPercent = ((netProfit / monthInvestment) * 100).toFixed(2);

  //         monthWiseData[monthKey] = Number(monthPercent);
  //         monthWiseProfitLoss[monthKey] = { totalProfit, totalLoss };
  //       });

  //       const sortedMonths = Object.keys(monthWiseData).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       const chartProfits = sortedMonths.map((month) => monthWiseData[month]);

  //       const barColors = chartProfits.map((p) =>
  //         p < 0 ? "rgba(236, 34, 19, 0.6)" : "rgba(15, 230, 122, 0.6)"
  //       );

  //       setCashChartData({
  //         labels: sortedMonths.map((m) => {
  //           const [year, month] = m.split("-");
  //           return new Date(year, month - 1).toLocaleString("default", {
  //             month: "short",
  //             year: "2-digit",
  //           });
  //         }),
  //         datasets: [
  //           {
  //             label: "Cash (%)",
  //             data: chartProfits,
  //             backgroundColor: barColors,
  //             tooltipData: sortedMonths.map((m) => monthWiseProfitLoss[m]),
  //           },
  //         ],
  //         options: {
  //           responsive: true,
  //           plugins: {
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const month = sortedMonths[context.dataIndex];
  //                   const { totalProfit, totalLoss } = monthWiseProfitLoss[month] || {};
  //                   const value = chartProfits[context.dataIndex].toFixed(2);
  //                   return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
  //                 },
  //               },
  //             },
  //           },
  //           scales: {
  //             y: {
  //               ticks: {
  //                 callback: function (value) {
  //                   return value.toFixed(2) + "%";
  //                 },
  //               },
  //               min: Math.min(...chartProfits, 0) * 1.2,
  //               max: Math.max(...chartProfits, 0) * 1.2,
  //             },
  //           },
  //         },
  //       });

  //       setCashPastdata(chartProfits);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  const getCashpastdata = async () => {
    try {
      const response = await getpastperformaceCashdata(
        { id: "66d2c3bebf7e6dc53ed07626" },
        token
      );

      if (response?.status) {
        const allDurations = response.data;

        const durationKeys = Object.keys(allDurations);
        const lastKey = durationKeys[durationKeys.length - 1] || "";
        const lastDuration = allDurations[lastKey];

        const months = lastDuration?.months || {};

        // 🔹 Dynamic future profit percentage (using backend)
        const futureProfitPercentage =
          lastDuration?.netProfitPercentageaverall ?? 0;

        setCashAvgProfit(Number(futureProfitPercentage)); // 🔹 now from backend %

        // 🔹 Month-wise chart data
        const monthWiseData = {};
        const monthWiseProfitLoss = {};

        Object.keys(months).forEach((month) => {
          const [year, m] = month.split("-");
          const monthKey = `${year}-${m.padStart(2, "0")}`;
          const {
            totalProfit = 0,
            totalLoss = 0,
            netProfitPercentage = 0,
          } = months[month];

          monthWiseData[monthKey] = Number(netProfitPercentage);
          monthWiseProfitLoss[monthKey] = { totalProfit, totalLoss };
        });

        const sortedMonths = Object.keys(monthWiseData).sort((a, b) => {
          const [yearA, monthA] = a.split("-").map(Number);
          const [yearB, monthB] = b.split("-").map(Number);
          return yearA - yearB || monthA - monthB;
        });

        const chartProfits = sortedMonths.map((month) => monthWiseData[month]);

        const barColors = chartProfits.map((p) =>
          p < 0 ? "rgba(236, 34, 19, 0.6)" : "rgba(15, 230, 122, 0.6)"
        );

        setCashChartData({
          labels: sortedMonths.map((m) => {
            const [year, month] = m.split("-");
            return new Date(year, month - 1).toLocaleString("default", {
              month: "short",
              year: "2-digit",
            });
          }),
          datasets: [
            {
              label: "Cash (%)",
              data: chartProfits,
              backgroundColor: barColors,
              tooltipData: sortedMonths.map((m) => monthWiseProfitLoss[m]),
            },
          ],
          options: {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const month = sortedMonths[context.dataIndex];
                    const { totalProfit, totalLoss } =
                      monthWiseProfitLoss[month] || {};
                    const value = chartProfits[context.dataIndex].toFixed(2);
                    return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}%`;
                  },
                },
              },
            },
            scales: {
              y: {
                ticks: {
                  callback: function (value) {
                    return value.toFixed(2) + "%";
                  },
                },
                min: Math.min(...chartProfits, 0) * 1.2,
                max: Math.max(...chartProfits, 0) * 1.2,
              },
            },
          },
        });

        setCashPastdata(chartProfits);
      }
    } catch (error) {
      console.error("Error fetching Cash data:", error);
    }
  };





  const getFuturepastdata = async () => {
    try {
      const response = await getpastperformaceCashdata(
        { id: "66dfede64a88602fbbca9b72" },
        token
      );

      if (response?.status) {
        const allDurations = response.data;

        // 🔹 Use only last duration (12_months)
        const durationKeys = Object.keys(allDurations);
        const lastKey = durationKeys[durationKeys.length - 1] || "";
        const lastDuration = allDurations[lastKey];

        const lastNetProfit = lastDuration?.totalNetProfit || 0;
        setFutureAvgProfit(lastNetProfit);

        // 🔹 Month-wise data from last duration only
        const months = lastDuration?.months || {};
        const monthWiseData = {};
        const monthWiseProfitLoss = {}; // for tooltip

        Object.keys(months).forEach((month) => {
          const [year, m] = month.split("-");
          const monthKey = `${year}-${m.padStart(2, "0")}`;

          const netProfit = months[month]?.netProfit ?? 0;

          monthWiseData[monthKey] = netProfit;
          monthWiseProfitLoss[monthKey] = {
            totalProfit: months[month]?.totalProfit ?? 0,
            totalLoss: months[month]?.totalLoss ?? 0,
          };
        });

        // 🔹 Sort months properly
        const sortedMonths = Object.keys(monthWiseData).sort((a, b) => {
          const [yearA, monthA] = a.split("-").map(Number);
          const [yearB, monthB] = b.split("-").map(Number);
          return yearA - yearB || monthA - monthB;
        });

        // 🔹 Use raw netProfit for chart
        const chartProfits = sortedMonths.map((month) => monthWiseData[month] ?? 0);

        // 🔹 Set bar colors
        const barColors = chartProfits.map((p) =>
          p < 0 ? "rgba(236, 34, 19, 0.6)" : "rgba(15, 230, 122, 0.6)"
        );

        // 🔹 Update Chart
        setFutureChartData({
          labels: sortedMonths.map((m) => {
            const [year, month] = m.split("-");
            return new Date(year, month - 1).toLocaleString("default", {
              month: "short",
              year: "2-digit",
            });
          }),
          datasets: [
            {
              label: "Future Performance",
              data: chartProfits,
              backgroundColor: barColors,
              tooltipData: sortedMonths.map((m) => monthWiseProfitLoss[m]),
            },
          ],
          options: {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const month = sortedMonths[context.dataIndex];
                    const { totalProfit, totalLoss } = monthWiseProfitLoss[month] || {};
                    const value = chartProfits[context.dataIndex].toFixed(2);
                    return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}`;
                  },
                },
              },
            },
            scales: {
              y: {
                min: Math.min(...chartProfits, 0) * 1.2,
                max: Math.max(...chartProfits, 0) * 1.2,
                ticks: {
                  callback: function (value) {
                    return value.toFixed(2); // show actual value, not %
                  },
                },
              },
            },
          },
        });

        // 🔹 Set raw past data if needed
        setCashPastdata(chartProfits);
      }
    } catch (error) {
      console.error("Error fetching Cash data:", error);
    }
  };




  const getOptionpastdata = async () => {
    try {
      const response = await getpastperformaceCashdata(
        { id: "66dfeef84a88602fbbca9b79" },
        token
      );

      if (response?.status) {
        const allDurations = response.data;

        const durationKeys = Object.keys(allDurations);
        const lastKey = durationKeys[durationKeys.length - 1] || "";
        const lastDuration = allDurations[lastKey];

        const lastNetProfit = lastDuration?.totalNetProfit || 0;
        setOptionAvgProfit(lastNetProfit);

        const months = lastDuration?.months || {};
        const monthWiseData = {};
        const monthWiseProfitLoss = {};

        Object.keys(months).forEach((month) => {
          const [year, m] = month.split("-");
          const monthKey = `${year}-${m.padStart(2, "0")}`;

          const netProfit = months[month]?.netProfit ?? 0;

          monthWiseData[monthKey] = netProfit;
          monthWiseProfitLoss[monthKey] = {
            totalProfit: months[month]?.totalProfit ?? 0,
            totalLoss: months[month]?.totalLoss ?? 0,
          };
        });

        const sortedMonths = Object.keys(monthWiseData).sort((a, b) => {
          const [yearA, monthA] = a.split("-").map(Number);
          const [yearB, monthB] = b.split("-").map(Number);
          return yearA - yearB || monthA - monthB;
        });


        const chartProfits = sortedMonths.map((month) => monthWiseData[month] ?? 0);


        const barColors = chartProfits.map((p) =>
          p < 0 ? "rgba(236, 34, 19, 0.6)" : "rgba(15, 230, 122, 0.6)"
        );


        setOptionChartData({
          labels: sortedMonths.map((m) => {
            const [year, month] = m.split("-");
            return new Date(year, month - 1).toLocaleString("default", {
              month: "short",
              year: "2-digit",
            });
          }),
          datasets: [
            {
              label: "Future Performance",
              data: chartProfits,
              backgroundColor: barColors,
              tooltipData: sortedMonths.map((m) => monthWiseProfitLoss[m]),
            },
          ],
          options: {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const month = sortedMonths[context.dataIndex];
                    const { totalProfit, totalLoss } = monthWiseProfitLoss[month] || {};
                    const value = chartProfits[context.dataIndex].toFixed(2);
                    return `Profit: ${totalProfit}, Loss: ${totalLoss}, Value: ${value}`;
                  },
                },
              },
            },
            scales: {
              y: {
                min: Math.min(...chartProfits, 0) * 1.2,
                max: Math.max(...chartProfits, 0) * 1.2,
                ticks: {
                  callback: function (value) {
                    return value.toFixed(2);
                  },
                },
              },
            },
          },
        });
        setCashPastdata(chartProfits);
      }
    } catch (error) {
      console.error("Error fetching Cash data:", error);
    }
  };




  const chartData = {
    labels: months,
    datasets: [
      {
        label: "Cash",
        data: cashpastdata.map(item => parseFloat(item.toFixed(2))),
        backgroundColor: "rgba(29, 235, 235, 1)",
      },
      {
        label: "Future",
        data: futurepastdata.map(item => parseFloat(item.toFixed(2))),
        backgroundColor: "rgba(94, 18, 247, 1)",
      },
      {
        label: "Option",
        data: optionpastdata.map(item => parseFloat(item.toFixed(2))),
        backgroundColor: "rgba(233, 121, 9, 1)",
      },
    ],
  }

  const options = {
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
        grid: {
          color: "rgba(255,255,255,0.2)",
        },
      },
      y: {
        ticks: {
          color: "#ffffff", // Y-axis labels white
        },
        grid: {
          color: "rgba(255,255,255,0.2)",
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "#ffffff", // legend white
        },
      },
    },
  };

  const isRestricted =
    userdata?.freetrial == 0

  const neonChartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      sparkline: { enabled: true },
      background: "transparent",
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: ["#4a8158c0"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        type: "diagonal1",
        opacityFrom: 0.9,
        opacityTo: 0.3,
        stops: [0, 100],
        colorStops: [
          {
            offset: 0,
            color: "#000000",
            opacity: 1,
          },
          {
            offset: 100,
            color: "#4a8158c0",
            opacity: 0.8,
          },
        ],
      },
    },
    grid: {

      show: false,
    },
    xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { labels: { show: false } },
    dataLabels: { enabled: false },
    tooltip: { enabled: false },
  };

  const neonChartSeries = [
    {
      name: "Income",
      data: [5, 15, 10, 25, 20, 30, 40, 55, 45, 60],
    },
  ];


  return (

    <div className="dashboard-container">
      <div className="page-titles">
        <nav className="breadcrumb">
          <div className="col-lg-6 col-sm-6 col-12">
            <ul className="breadcrumb-links">
              <li>
                <a className="bx bx-home-alt text-white" href="/" style={{ fontSize: "20px", marginLeft: "3px", marginTop: "5px" }} />



              </li>
              <li style={{ width: "3px" }} className="text-white">
                <Tally1 />
              </li>
              <li>
                <div className="breadcrumb-box">
                  <h6 className="heading-color mb-0 breadcrumb-text">
                    Dashboard
                  </h6>
                </div>
              </li>
            </ul>
          </div>

        </nav>
      </div>

      <div className="row g-4">
        {/* Profile Card */}
        <div className="col-lg-3">
          <div className="profile-card-user card h-100 text-center">
            <div className="card-body">
              <div className="avatar mx-auto mb-3">
                <img
                  src={image || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTox5GjcAiQFx_AhZfdb1Y4Y5TViXM613ATDg&s"}
                  alt="User"
                  className="img-fluid rounded-circle"
                />
              </div>
              <h4 className="username">Hello, {userDetail?.FullName}</h4>
              <hr />
              <h6 className="wallet-label">Wallet Balance</h6>
              <p className="wallet-balance mb-0">₹{(userDetail?.wamount)?.toFixed(2)}</p>
            </div>
          </div>
        </div>

        {/* Graph Section */}
        <div className="col-lg-9">


          <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3">
            <Link to={isRestricted ? "#" : "/user/trades"}>
              <div className="col position-relative">
                <div
                  className="card radius-10 bg-gradient-deepblue"
                  style={{
                    filter: isRestricted ? "blur(3px)" : "none",
                    pointerEvents: isRestricted ? "none" : "auto",
                    userSelect: "none",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <h5 className="mb-0 text-white">{dashboard?.open}</h5>
                      <div className="ms-auto">
                        <i className="bx bx-trending-up fs-3 text-white" />

                      </div>
                    </div>
                    <div
                      className="progress my-2 bg-opacity-25 bg-white"
                      style={{ height: 4 }}
                    >
                      <div
                        className="progress-bar bg-white"
                        role="progressbar"
                        style={{ width: "55%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                    <div className="d-flex align-items-center text-white">
                      <p className="mb-0 text-white">Live Trade</p>
                    </div>
                  </div>
                  <Chart options={neonChartOptions} series={neonChartSeries} type="area" height={150} />
                </div>


                {isRestricted && (
                  <Link to="/user/service"> <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "10px",
                      backdropFilter: "blur(5px)",
                    }}
                  >
                    <img src="/assets/images/Locked.gif" style={{ width: "30%" }}
                      alt="lock" />
                    {/* <Lock size={40} color="white" /> */}
                    <p className="mt-2 text-white fw-bold">Unlock</p>
                  </div>
                  </Link>
                )}
              </div>
            </Link>
            <Link to={isRestricted ? "#" : "/user/trades"} state={"closetrade"}>
              <div className="col position-relative">

                <div
                  className="card radius-10 bg-gradient-ohhappiness"
                  style={{
                    filter: isRestricted ? "blur(3px)" : "none",
                    pointerEvents: isRestricted ? "none" : "auto",
                    userSelect: "none",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <h5 className="mb-0 text-white">{dashboard?.closed}</h5>
                      <div className="ms-auto">
                        <i className="bx bx-x-circle fs-3 text-white" />

                      </div>
                    </div>
                    <div className="progress my-2 bg-opacity-25 bg-white" style={{ height: 4 }}>
                      <div
                        className="progress-bar bg-white"
                        role="progressbar"
                        style={{ width: "55%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                    <div className="d-flex align-items-center text-white">
                      <p className="mb-0 text-white">Close Trade</p>
                    </div>
                  </div>
                  <Chart options={neonChartOptions} series={neonChartSeries} type="area" height={150} />

                </div>


                {isRestricted && (
                  <Link to="/user/service"> <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "10px",
                      backdropFilter: "blur(5px)",
                    }}
                  >
                    <img src="/assets/images/Locked.gif" style={{ width: "30%" }}
                      alt="lock" />
                    <p className="mt-2 text-white fw-bold">Unlock</p>
                  </div>
                  </Link>
                )}
              </div>

            </Link>
            <Link to={isRestricted ? "#" : "/user/strategy"}>
              <div className="col position-relative">

                <div
                  className="card radius-10 bg-gradient-ibiza"
                  style={{
                    filter: isRestricted ? "blur(3px)" : "none",
                    pointerEvents: isRestricted ? "none" : "auto",
                    userSelect: "none",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <h5 className="mb-0 text-white">{dashboard?.openstrategy}</h5>
                      <div className="ms-auto">
                        <i className="bx bx-line-chart fs-3 text-white" />
                      </div>
                    </div>
                    <div className="progress my-2 bg-opacity-25 bg-white" style={{ height: 4 }}>
                      <div
                        className="progress-bar bg-white"
                        role="progressbar"
                        style={{ width: "55%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                    <div className="d-flex align-items-center text-white">
                      <p className="mb-0 text-white">Strategy Trade</p>
                    </div>
                  </div>
                  <Chart options={neonChartOptions} series={neonChartSeries} type="area" height={150} />

                </div>


                {isRestricted && (
                  <Link to="/user/service"> <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "10px",
                      backdropFilter: "blur(5px)",
                    }}

                  >
                    <img src="/assets/images/Locked.gif" style={{ width: "30%" }} alt="lock" />
                    {/* <i className="bx bx-lock-alt fs-1 text-white" ></i> */}
                    <p className="mt-2 text-white fw-bold">Unlock</p>
                  </div>

                  </Link>
                )}
              </div>
            </Link>
          </div>

        </div>
      </div>

      <div class="row g-3 mt-4" >
        <div className="card h-100 user-card px-0">
          <div className="card-header ">
            <h5 className="mb-0">Ouick Access & Updates</h5>
          </div>
          <div className="card-body">






            <div className="row mt-3">
              <div className="col-lg-4 col-md-4">
                <div className="card  profile-card-user h-100">

                  <div className="card-body">
                    {/* <div className="d-flex flex-column align-items-center text-center">
                <div className="btn-primary  rounded-circle " style={{ marginTop: '-50px', width: '100px', height: '100px' }}>
                  <img
                    src={image || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTox5GjcAiQFx_AhZfdb1Y4Y5TViXM613ATDg&s"}
                    alt="User"
                    style={{
                      width: "100px",
                      height: "100px",
                      backgroundColor: "#f1f1f1",
                      borderRadius: "50%",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}

                  />
                </div>
                <div className="mt-3">
                  <h4>Hello,{userDetail?.FullName}</h4>
                  <hr />
                  <h3 class="h6 fw-semibold">Wallet Balance</h3>
                  <p class="h3 font-weight-bold">₹<span id="totalBalance">{(userDetail?.wamount)?.toFixed(2)}</span></p>


                </div>
              </div>
              <hr className="my-3" /> */}

                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        <Link to="/user/subscription" className="text-white">
                          <Rocket className="me-2 text-white" /> My Plan Subscription
                        </Link>
                      </li>
                      <li className="list-group-item">
                        <Link
                          onClick={() => {
                            if (userdata.kyc_verification !== 1) setViewModel2(true);
                          }}
                          className={`text-decoration-none d-flex align-items-center ${userdata.kyc_verification === 1 ? 'text-success' : 'text-danger'
                            }`}
                          style={{ pointerEvents: userdata.kyc_verification === 1 ? 'none' : 'auto' }}
                        >
                          <Shield
                            className={`me-2 ${userdata.kyc_verification === 1 ? 'text-success' : 'text-danger'
                              }`}
                          />
                          <span className="text-white">KYC -</span>
                          {userdata.kyc_verification === 1 ? 'Completed' : 'Pending'}
                        </Link>
                      </li>

                      <li className="list-group-item">
                        <Link to="/user/subscription" className="text-white">
                          <History className="me-2 text-warning" /> Payment History
                        </Link>
                      </li>
                      <li className="list-group-item">
                        <Link to="/user/subscription" state={{ activeTab: 'basket' }} className="text-white">
                          <ShoppingCart className="me-2 text-white" /> My Basket Subscription
                        </Link>
                      </li>
                      <li className="list-group-item">
                        <Link to="/user/refer-earn" className="text-white">
                          <Puzzle className="me-2 text-white" /> Refer & Earn
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-8">
                <Swiper
                  spaceBetween={50}
                  slidesPerView={1}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Autoplay, Navigation, Pagination]}

                >

                  {bannerimg?.map((item, index) => (
                    <SwiperSlide key={index}>
                      {item?.hyperlink ? (
                        <a
                          href={item.hyperlink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={item.image}
                            style={{ height: "300px", width: "100%", cursor: "pointer" }}
                            alt={`banner-${index}`}
                          />
                        </a>
                      ) : (
                        <img
                          src={item.image}
                          // src={`${image_baseurl}uploads/banner/${item.image}`}
                          style={{ height: "300px", width: "100%" }}
                          alt={`banner-${index}`}
                        />
                      )}
                    </SwiperSlide>
                  ))}


                </Swiper>
              </div>

            </div>

          </div>
        </div>

      </div>
      <div class="row g-3 mt-4" >
        <div className="card h-100 user-card px-0">
          <div className="card-header ">
            <div className="">
              <h5 className="mb-0">Live Performance</h5>
            </div>
          </div>
          <div className="card-body">

            <div className="row g-4">


              <div className="col-md-4">
                <div className="card graph-card h-100">
                  <div className="card-body">
                    <Link to="/user/past-performance/cash" className="text-decoration-none text-white">
                      <h5 className="text-yellow">Cash</h5>
                    </Link>

                    {cashChartData && (
                      <Chart
                        type="area"
                        height={250}
                        series={[
                          {
                            name: "Cash (%)",
                            data: cashChartData?.datasets[0]?.data.map((v) =>
                              parseFloat(v.toFixed(2))
                            ) || [],
                          },
                        ]}
                        options={{
                          chart: { toolbar: { show: false }, zoom: { enabled: false } },
                          stroke: { curve: "smooth", width: 2 },
                          fill: { type: "gradient", gradient: { opacityFrom: 0.4, opacityTo: 0 } },
                          colors: ["#5E12F7"],
                          xaxis: {
                            categories: cashChartData?.labels || [],
                            labels: { style: { colors: "#aaa" } },
                            // title: { text: "Duration", style: { color: "#aaa" } },
                          },
                          yaxis: {
                            labels: {
                              style: { colors: "#aaa" },
                              formatter: (val) => parseFloat(val).toFixed(2) + "%",
                            },
                            title: { text: "Percentage (%)", style: { color: "#aaa" } },
                          },
                          tooltip: {
                            theme: "dark",
                            y: {
                              formatter: (val) => parseFloat(val).toFixed(2) + "%",
                            },
                          },
                          legend: { labels: { colors: "#FFD700" } },
                          grid: { borderColor: "rgba(255,255,255,0.1)" },
                        }}
                      />
                    )}

                    <hr />
                    <div className="profit-info d-flex align-items-center">
                      <i className="bx bx-rupee profit-icon"></i>
                      <div>
                        <h6>Net Profit</h6>
                        <h4 className={`${cashAvgProfit < 0 ? "text-danger" : "text-success"}`}>{cashAvgProfit.toFixed(2)}<span className="text-white">%</span></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/* Future Graph */}
              <div className="col-md-4">
                <div className="card graph-card h-100">
                  <div className="card-body">

                    <Link to="/user/past-performance/future" className="text-decoration-none text-white">
                      <h5 className="text-yellow">Future</h5>
                    </Link>
                    {futureChartData && (
                      <Chart
                        type="area"
                        height={250}
                        series={[
                          {
                            name: "Future",
                            data: futureChartData?.datasets[0]?.data.map((v) =>
                              parseFloat(v.toFixed(2))
                            ) || [],
                          },
                        ]}
                        options={{
                          chart: { toolbar: { show: false }, zoom: { enabled: false } },
                          stroke: { curve: "smooth", width: 2 },
                          fill: { type: "gradient", gradient: { opacityFrom: 0.4, opacityTo: 0 } },
                          colors: ["#5E12F7"],
                          xaxis: {
                            categories: futureChartData?.labels || [],
                            labels: { style: { colors: "#aaa" } },
                            // title: { text: "Duration", style: { color: "#aaa" } },
                          },
                          yaxis: {
                            labels: {
                              style: { colors: "#aaa" },
                              formatter: (val) => parseFloat(val).toFixed(2),
                            },
                            title: { text: "Percentage", style: { color: "#aaa" } },
                          },
                          tooltip: {
                            theme: "dark",
                            y: {
                              formatter: (val) => parseFloat(val).toFixed(2),
                            },
                          },
                          legend: { labels: { colors: "#FFD700" } },
                          grid: { borderColor: "rgba(255,255,255,0.1)" },
                        }}
                      />
                    )}
                    <hr />
                    <div className="profit-info d-flex align-items-center">
                      <i className="bx bx-rupee profit-icon"></i>
                      <div>
                        <h6>Net Profit</h6>
                        <h4 className={`${futureAvgProfit < 0 ? "text-danger" : "text-success"}`}>{futureAvgProfit.toFixed(2)}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Option Graph */}
              <div className="col-md-4">
                <div className="card graph-card h-100">
                  <div className="card-body">
                    <Link to="/user/past-performance/option" className="text-decoration-none text-white">
                      <h5 className="text-yellow">Option</h5>
                    </Link>
                    {optionChartData && (
                      <Chart
                        type="area"
                        height={250}
                        series={[
                          {
                            name: "Option",
                            data: optionChartData?.datasets[0]?.data.map((v) =>
                              parseFloat(v.toFixed(2))
                            ) || [],
                          },
                        ]}
                        options={{
                          chart: { toolbar: { show: false }, zoom: { enabled: false } },
                          stroke: { curve: "smooth", width: 2 },
                          fill: { type: "gradient", gradient: { opacityFrom: 0.4, opacityTo: 0 } },
                          colors: ["#5E12F7"],
                          xaxis: {
                            categories: optionChartData?.labels || [],
                            labels: { style: { colors: "#aaa" } },
                            // title: { text: "Duration", style: { color: "#aaa" } },
                          },
                          yaxis: {
                            labels: {
                              style: { colors: "#aaa" },
                              formatter: (val) => parseFloat(val).toFixed(2),
                            },
                            title: { text: "Percentage", style: { color: "#aaa" } },
                          },
                          tooltip: {
                            theme: "dark",
                            y: {
                              formatter: (val) => parseFloat(val).toFixed(2),
                            },
                          },
                          legend: { labels: { colors: "#FFD700" } },
                          grid: { borderColor: "rgba(255,255,255,0.1)" },
                        }}
                      />
                    )}
                    <hr />
                    <div className="profit-info d-flex align-items-center">
                      <i className="bx bx-rupee profit-icon"></i>
                      <div>
                        <h6>Net Profit</h6>
                        <h4 className={`${optionAvgProfit < 0 ? "text-danger" : "text-success"}`}>{optionAvgProfit?.toFixed(2)}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div >
      <ReusableModal
        show={viewmodel2}
        onClose={() => setViewModel2(false)}
        title={<>KYC</>}
        body={
          <Kyc
            onSuccess={() => {
              setViewModel2(false);
            }}
            type="dashboard"

          />
        }
        size="lg"
      />
    </div >


  );
};

export default Dashboard;
